import _defineProperty from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

export var Arrays;

(function (Arrays) {
  /** Convert an array of arrays into a single array */
  function flatten() {
    for (var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++) {
      arrays[_key] = arguments[_key];
    }

    return arrays.reduce(function (output, current) {
      return current ? [].concat(_toConsumableArray(output), _toConsumableArray(current)) : output;
    }, []);
  }

  Arrays.flatten = flatten;
  /** Turn an array into a dictionary of items in that array by a given key */

  function arrayToDictionary(array, getKey) {
    return array.reduce(function (dictionary, currentValue) {
      var key = typeof getKey === 'function' ? getKey(currentValue) : currentValue[getKey];
      return Object.assign(Object.assign({}, dictionary), _defineProperty({}, key, currentValue));
    }, {});
  }

  Arrays.arrayToDictionary = arrayToDictionary;
  /** Sort an array into a dictionary of arrays keyed by a value to sort on */

  function arrayToArrayDictionary(array, getKey) {
    return array.reduce(function (dictionary, currentValue) {
      var key = getKey(currentValue);
      return Object.assign(Object.assign({}, dictionary), _defineProperty({}, key, [].concat(_toConsumableArray(dictionary[key] || []), [currentValue])));
    }, {});
  }

  Arrays.arrayToArrayDictionary = arrayToArrayDictionary;
  /** Sort an array into an array of objects with a key and an array of items on it */

  function arrayToArraysByKey(array, getKey) {
    var dictionary = arrayToArrayDictionary(array, getKey);
    return Object.keys(dictionary).map(function (key) {
      return {
        key: key,
        items: dictionary[key]
      };
    });
  }

  Arrays.arrayToArraysByKey = arrayToArraysByKey;
  /** A variant of findIndex that returns the index of the last item in the array where the callback returns true */

  function findLastIndex(array, callback) {
    return array.reduce(function (output, item, index) {
      return callback(item) ? index : output;
    }, -1);
  }

  Arrays.findLastIndex = findLastIndex;
  /**
   * Re-indexes an array from a specific index point.
   * - Does not mutate the passed array, returns a new one.
   * @example If `["a", "b", "c", "d", "e"]` was passed with a `startFrom` index of `2`, the result would be `["c", "d", "e", "a", "b"]`
   * @param array The array to clone and re-index.
   * @param startFrom The current index of the new first item.
   * @returns A new array, re-indexed with the item at the `startFrom` index now first.
   */

  function reIndex(array, startFrom) {
    if (startFrom === 0) {
      return _toConsumableArray(array);
    }

    return [].concat(_toConsumableArray(array.slice(startFrom)), _toConsumableArray(array.slice(0, startFrom)));
  }

  Arrays.reIndex = reIndex;
  /**
   * A version of `map` which loops a specified number of times and returns the index as the map arg.
   * - Useful when you want to run a `map` x number of times but you don't have a specific array to loop.
   * @param count The number of times to run the mapper.
   * @param mapper A function to call x number of times (x = `count`).
   * @returns The array of newly mapped items.
   */

  function repeat(count, mapper) {
    var array = [];

    for (var i = 0; i < count; i += 1) {
      array.push(i);
    }

    return array.map(mapper);
  }

  Arrays.repeat = repeat;
  /** Utils for working with arrays of arrays - useful when an array has been split into groups but you want to interact with it as if it's still a single array, I.E using a single overall index */

  var NestedArrays;

  (function (NestedArrays) {
    /**
     * Get the overall index of an item inside an array of arrays
     *
     * I.E. [[0,1,2], [3,4], [5,6,7]]
     */
    function getOverallIndex(innerIndex, outerIndex, arrays) {
      return arrays.slice(0, outerIndex).reduce(function (output, array) {
        return array.items.length + output;
      }, 0) + innerIndex;
    }

    NestedArrays.getOverallIndex = getOverallIndex;
    /** Get the item inside an array of arrays at an overall index */

    function getAtOverallIndex(index, arrays) {
      var totalIndex = 0;

      var _iterator = _createForOfIteratorHelper(arrays),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var array = _step.value;
          var newIndex = totalIndex + array.items.length;

          if (index < newIndex) {
            return array.items[index - totalIndex];
          }

          totalIndex = newIndex;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    NestedArrays.getAtOverallIndex = getAtOverallIndex;
  })(NestedArrays = Arrays.NestedArrays || (Arrays.NestedArrays = {}));
})(Arrays || (Arrays = {}));